import { observable, action } from 'mobx';
class OnboardingStore {
  @observable showVersionWithOnboarding = false;
  @observable isProductApproved = false;

  @observable checkList = {
    hasModule: false,
    hasContent: false,
    publishedContent: false
  };

  @action
  setShowVersionWithOnboarding(status) {
    this.showVersionWithOnboarding = status;
  }

  @action
  setProductIsApproved(status) {
    this.isProductApproved = status;
  }

  @action
  setCheckList(data) {
    this.checkList = data;
  }
}

export default new OnboardingStore();
